import rolesApi from "../../api/rolesApi";

const state = { roles: [] };

const actions = {
    createRole({ commit }, role) {
        return new Promise((resolve, reject) => {
            rolesApi.store(role)
                .then((response) => {
                    if (response.status === 200) {
                        commit("ADD_ROLE", response.data.role);
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    getRoles({ commit }) {
        return new Promise((resolve, reject) => {
            rolesApi
                .all()
                .then((response) => {
                    if (response.status === 200) {
                        commit("SET_ROLE", response.data);
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    updateRole({ commit }, data) {
        return new Promise((resolve, reject) => {
            rolesApi
                .update(data)
                .then((response) => {
                    if (response.status === 200) {
                        commit("UPDATE_ROLE", response.data.roleUpdated);
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    deleteRole({ commit }, roleId) {
        return new Promise((resolve, reject) => {
            rolesApi
                .delete(roleId)
                .then((response) => {
                    if (response.status === 200) {
                        commit("DELETE_ROLE", roleId);
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);

                });
        });
    },
};
const mutations = {
    ADD_ROLE: (state, role) => state.roles.unshift(role),
    SET_ROLE: (state, roles) => (state.roles = roles),

    UPDATE_ROLE: (state, role) => {
        const index = state.roles.findIndex(
            (role) => role.id === role.id
        );

        if (index !== -1) {
            state.roles.splice(index, 1, role);
        }
    },

    DELETE_ROLE: (state, roleID) => {
        state.roles = state.roles.filter(
            (role) => role.id !== roleID
        );
    },
};
export default { state, actions, mutations };